import PropTypes from 'prop-types';

// Logo component that renders the Astron logo SVG
const AstronLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      version="1.1"
      viewBox="0 0 1200 964"
      width="300"
      height="241"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform="translate(378,257)"
        d="m0 0h443l1 1v445l-2 1h-441l-1-1zm141 24-116 1-1 117 2 2 18-13 13-11 10-8 10-9 13-12 12-12 7-8 12-14 15-20 8-11-1-2zm32 1-7 11-14 21-10 13-9 11-13 15-12 13-15 14-11 9-10 9-19 14-23 15-5 3v101l19 12 16 12 13 10 13 11 10 9 26 26 9 11 11 13 13 18 12 18 5 8h99l4-4 10-16 12-17 10-13 12-14 9-10 29-29 11-9 12-10 17-12 17-11 4-2 1-2v-99l-10-7-15-10-18-13-13-11-11-9-16-15-11-11-7-8-12-14-14-18-14-21-7-11-1-1zm127 0 2 5 14 18 8 10 12 14 11 12 17 17 8 7 14 12 17 13 15 11h1v-119zm118 278-14 10-16 13-11 9-17 16-14 14-7 8-9 10-11 14-11 15-6 8v2h117v-119zm-393 1v118h117l-7-11-11-15-9-11-12-14-16-17-15-14-10-9-14-11-13-10-9-6z"
        fill="#042255"
      />
      <path
        transform="translate(352,429)"
        d="m0 0h3v26l-4 3-26 10-33 11-7 2 22 6 24 8 23 10 1 1v26l-6-1-21-9-36-12-23-6-26-5-21-3-13-1-27-1-4-2v-24l37-2 31-4 29-6 26-7 31-11 18-8z"
        fill="#F2092C"
      />
      <path
        transform="translate(845,429)"
        d="m0 0 5 1 27 11 27 9 22 6 31 6 36 4 28 2 1 1v22l-1 1-48 4-32 5-25 6-27 8-29 11-14 6h-1v-27l11-5 26-10 23-7 8-2-3-2-30-9-26-10-9-4z"
        fill="#F2092C"
      />
      <path
        transform="translate(587,60)"
        d="m0 0h24l1 1 2 32 3 27 5 28 7 27 11 33 6 15 6 12-1 1h-26l-4-6-10-26-7-21-4-13-1-2-7 25-7 20-8 20-2 3h-26v-4l7-16 9-25 7-23 7-30 4-25 3-32z"
        fill="#F1092C"
      />
      <path
        transform="translate(548,727)"
        d="m0 0h28l8 20 7 20 9 28h1l5-20 11-31 6-15 2-2h27l-2 6-8 19-9 25-7 24-6 27-4 25-2 24-1 26-5 1h-19l-1-1-3-41-4-30-6-28-8-28-11-30-8-18z"
        fill="#F1092C"
      />
      <path
        transform="translate(663,282)"
        d="m0 0h15l10 14 10 13 11 13 12 14 21 21 8 7 14 12 17 13 16 12-1 29-11-6-20-14-12-9-11-9-14-12-13-12-13-13-7-8-12-14-14-18-14-21-6-10v-1z"
        fill="#F2082B"
      />
      <path
        transform="translate(526,282)"
        d="m0 0h16l9 1-6 10-14 21-10 13-9 11-13 15-12 13-16 15-11 9-10 9-19 14-23 15-5 2v-24l2-7 17-12 13-11 10-8 10-9 13-12 11-11 7-8 12-14 15-20 8-11z"
        fill="#F20A2C"
      />
      <path
        transform="translate(403,531)"
        d="m0 0 10 5 20 14 13 10 11 9 14 12 30 30 9 11 11 13 13 18 14 21-1 4h-28l-12-17-10-13-11-13-9-10-12-13-15-14-10-9-14-11-13-10-10-7z"
        fill="#F2092C"
      />
      <path
        transform="translate(794,532)"
        d="m0 0h2l1 3v24l-5 5-14 10-17 14-12 11-8 7-16 16-7 8-9 10-11 14-11 15-6 8-6 2h-15l-9-1 2-5 18-27 13-17 12-14 9-10 30-30 11-9 12-10 17-12 17-11z"
        fill="#F2092C"
      />
    </svg>
  );
};

AstronLogo.propTypes = {
  className: PropTypes.string,
};

// Spinner component that uses the AstronLogo with animation
const Spinner = ({ className = '' }) => {
  return (
    <div className="absolute flex w-full h-full justify-center items-center top-0 bottom-0 left-0 right-0">
      <AstronLogo className={`animate-bounce w-40 h-40 ${className}`} />
    </div>
  );
};

Spinner.propTypes = {
  className: PropTypes.string,
};

export { AstronLogo };
export default Spinner;
